import React from 'react'
import Card from "@material-ui/core/Card";

export const CabinetBookingElement = ({booking, type, cancelOrderClickCallback}) => (
    <Card className={`${type} one-element`}>
        <div>
            <div>{booking.room.studio_name}</div>
            <div>{booking.room.name}</div>
            <div>{booking.datetime} </div>
            <div>{booking.price} </div>
        </div>
        <div className="controls">
            {booking.room.studio_phone && (type === 'waiting' || type === 'accepted') ?
                <a href={`tel:${booking.room.studio_phone}`}>
                    <img className="phone_image" alt="phone-icon"
                         src={(process.env.NODE_ENV === 'development' ? 'http://tonesky.darlane' : '') + '/images/phone.png'}/>
                </a> : ''}
            {type === 'last' && booking.cabinet_booking_url ?
                <a href={booking.cabinet_booking_url} className="booking_url">
                    <div className="booking-button">
                        Повторить
                    </div>
                </a> : ''}
            {type === 'accepted' && booking.can_be_canceled
                ? <div className="cancel-booking-button" onClick={() => cancelOrderClickCallback(booking.id)}>
                    <img className="phone_image" alt="phone-icon"
                         src={(process.env.NODE_ENV === 'development' ? 'http://tonesky.darlane' : '') + '/images/cancel_booking.png'}/>
                </div>
                : ''}
            {type === 'accepted' && booking.recurrent_type
                ? <img className="recurrent-icon" alt="recurrent-icon-icon"
                       src={(process.env.NODE_ENV === 'development' ? 'http://tonesky.darlane' : '') + '/images/icons/recurrent-orange.svg'}/>
                : ''}
        </div>
    </Card>
);



